import React from 'react';
import { Modal, Box, Typography, Button } from '@mui/material';
import COLORS from '../../../resources/style/Themes';
import { useTranslation } from 'react-i18next';
import { StringKeys } from '../../../resources/strings/StringKeys';

const ImpactedUsersModalSales = ({
  show,
  onHide,
  previewResponse,
  proceedWithUpdate,
  organization,
}) => {
  const { t } = useTranslation();

  const opsAffectedUsers = previewResponse?.ops_affected_users ?? [];
  const respondAffectedUsers = previewResponse?.respond_affected_users ?? [];

  const displayUserList = (users) => {
    if (users.length === 0) {
      return (
        <Typography sx={{ mb: 1, fontStyle: 'italic' }}>
          {t(StringKeys.NO_USERS)}
        </Typography>
      );
    }
    return users.map((user, index) => (
      <Typography key={index} sx={{ mb: 1 }}>
        {user.first_name} {user.last_name}
      </Typography>
    ));
  };

  return (
    <Modal
      open={show}
      onClose={onHide}
      aria-labelledby="impacted-users-modal-title"
      aria-describedby="impacted-users-modal-description"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: 24,
          p: 3,
        }}
      >
        <Typography
          id="impacted-users-modal-title"
          variant="h6"
          sx={{
            mb: 2,
            textAlign: 'center',
            color: COLORS.WHITE,
            backgroundColor: COLORS.SAFEGUARD_BLUE,
            borderRadius: '8px',
            padding: '10px',
          }}
        >
          {t(StringKeys.MODIFY_SUBSCRIPTION_COUNT)}
        </Typography>
        <Typography id="impacted-users-modal-description" sx={{ mb: 2 }}>
          {t(
            StringKeys.ORGANIZATION_CURRENTLY_HAS_MORE_SUBSCRIBED_USERS_THAN_YOUR_REQUESTED_SUBSCRIPTION_COUNT,
            {
              organization: `${organization.company_name}`,
            },
          )}
        </Typography>
        <Typography sx={{ fontWeight: 'bold', mb: 1 }}>
          {t(StringKeys.OPS_AFFECTED_USERS)}
        </Typography>
        {displayUserList(opsAffectedUsers)}
        <Typography sx={{ fontWeight: 'bold', mb: 1, mt: 2 }}>
          {t(StringKeys.RESPOND_AFFECTED_USERS)}
        </Typography>
        {displayUserList(respondAffectedUsers)}
        <Box sx={{ textAlign: 'center', mt: 2 }}>
          <Button
            variant="contained"
            color="secondary"
            onClick={onHide}
            sx={{
              mr: 1,
            }}
          >
            {t(StringKeys.CANCEL)}
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => {
              proceedWithUpdate();
              onHide();
            }}
            sx={{
              ml: 1,
            }}
          >
            {t(StringKeys.FINISH)}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ImpactedUsersModalSales;
